var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('OrderSearch'),_c('OrderList',{attrs:{"stage":_vm.stage,"view-type":_vm.vt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }